import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
import { ShowroomGuestLinkDialogComponent } from "./components/showroom-guest-link-dialog/showroom-guest-link-dialog.component";
import { ShowroomHeaderComponent } from "./components/showroom-header/showroom-header.component";
import { ShowroomPreviewButtonComponent } from "./components/showroom-preview-button/showroom-preview-button.component";
import { ShowroomShortlistOverlayItemDialogComponent } from "./components/showroom-shortlist-overlay-item-dialog/showroom-shortlist-overlay-item-dialog.component";
import { ShowroomShortlistOverlayComponent } from "./components/showroom-shortlist-overlay/showroom-shortlist-overlay.component";
import { ShowroomShortlistTriggerComponent } from "./components/showroom-shortlist-trigger/showroom-shortlist-trigger.component";
import { ShowroomShowTemplatesButtonComponent } from "./components/showroom-show-templates-button/showroom-show-templates-button.component";

@NgModule({
  declarations: [
    ShowroomHeaderComponent,
    ShowroomShortlistTriggerComponent,
    ShowroomShortlistOverlayComponent,
    ShowroomGuestLinkDialogComponent,
    ShowroomPreviewButtonComponent,
    ShowroomShortlistOverlayItemDialogComponent,
    ShowroomShowTemplatesButtonComponent,
  ],
  imports: [SharedModule, RouterModule],
  exports: [
    ShowroomHeaderComponent,
    ShowroomShortlistTriggerComponent,
    ShowroomPreviewButtonComponent,
    ShowroomShowTemplatesButtonComponent,
  ],
  providers: [],
})
export class ShowroomsSharedModule {}
